import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";

const CopyToClipboardButton = ({ valueToCopy }) => {
  const { t } = useTranslation("Shared");

  const [copied, setCopied] = React.useState(false);

  const handleValueCopy = () =>
    navigator.clipboard.writeText(valueToCopy).then(() => setCopied(true));

  return (
    <Tooltip
      title={copied ? t("copied") : t("copy_to_clipboard")}
      arrow
      onMouseEnter={() => setCopied(false)}
      leaveDelay={500}
    >
      <IconButton
        onClick={handleValueCopy}
        color="primary"
        sx={{ padding: 1.25 }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default CopyToClipboardButton;
